import MicrosoftLogo from "@/assets/icons/icon-microsoft.svg";
import LogoutIcon from "@/assets/icons/log-out.svg";
import CenteredSpinner from "@/components/CenteredSpinner";
import useGetAuthData from "@/hooks/useGetAuthData";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import { useTranslation } from "react-i18next";
import { Button } from "../../ui/button";
import { DialogHeader, DialogTitle } from "../../ui/dialog";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import UserAvatar from "../../UserAvatar";
// import LanguageSelector from './LanguageSelector';
import TokenConsumptionCard from "./TokenConsumptionCard";

const MyAccountSettings = () => {
    const { t } = useTranslation();
    const { handleLogout } = useGetAuthData();
    const { data: user } = useGetUserProfile();

    if (!user) {
        return <CenteredSpinner />;
    }

    return (
        <div className="flex flex-col gap-8">
            <DialogHeader>
                <DialogTitle className="font-bold leading-none">
                    {t("settings.account.title")}
                </DialogTitle>
                <p className="text-xs">{t("settings.account.description")}</p>
            </DialogHeader>
            <div className="flex w-full flex-col items-center gap-2 py-2">
                <UserAvatar className="h-18 w-18" user={user} />
                <p className="text-sm font-medium">
                    {user.profile.displayName}
                </p>
            </div>
            <div className="flex gap-8">
                <div className="grid w-full max-w-sm items-center gap-1.5">
                    <Label htmlFor="firstname">
                        {t("settings.account.firstname")}
                    </Label>
                    <Input
                        className="disabled:opacity-100"
                        id="firstname"
                        type="text"
                        value={user.firstName}
                        disabled
                    />
                </div>
                <div className="grid w-full max-w-sm items-center gap-1.5">
                    <Label htmlFor="lastname">
                        {t("settings.account.lastname")}
                    </Label>
                    <Input
                        className="disabled:opacity-100"
                        id="lastname"
                        type="text"
                        value={user.lastName}
                        disabled
                    />
                </div>
            </div>
            <div>
                <h2 className="mb-2 text-sm font-medium uppercase text-text-caption">
                    {t("settings.account.connectedAccounts")}
                </h2>
                <div className="flex items-center gap-8 bg-surface-primary p-4">
                    <img alt="Microsoft" src={MicrosoftLogo} />
                    {user.profile.email}
                </div>
            </div>
            {/* Uncomment this part when SDK is ready to accept en-US language */}
            {/* <div className="flex flex-col gap-1.5">
                <Label>{t('settings.account.chooseLanguage')}</Label>
                <LanguageSelector />
                <p className="text-xs text-text-caption">
                    {t('settings.account.languageWarning')}
                </p>
            </div> */}
            <TokenConsumptionCard />
            <div className="mt-5">
                <Button
                    className="w-full"
                    onClick={handleLogout}
                    variant="outline"
                >
                    <img alt="Microsoft" src={LogoutIcon} />
                    {t("settings.account.disconnect")}
                </Button>
            </div>
        </div>
    );
};

export default MyAccountSettings;
